import {
  initialState,
  Actions,
  State,
  DELETE_INVITATION,
  DELETE_INVITATION_SUCCESS,
  DELETE_INVITATION_ERROR,
  RESET_DELETE_INVITATION,
} from '../../types/invitation/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_INVITATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_INVITATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_INVITATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_INVITATION:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
